<template>
  <div id='route-stop-detail'>
    <div v-if="loading"
         class="md-progress-spinner"
         md-mode="indeterminate"></div>
    <div v-if="!loading"
         class="stop-menu-content">
      <div class="stop-menu-header">
        <h4>{{ this.stopDetails.stopc }}</h4>

        <div class="favourite-button-wrap">
          <FavouriteButton :stopDetails="stopDetails"/>
        </div>
      </div>
      <div class="stop-menu-body">
        <!-- ETA and fare -->
        <div class="row stop-menu-row">
          <StopMenuContent></StopMenuContent>
        </div>

        <!-- more -->
        <div class="row"></div>

        <!-- more content -->
      </div>
      <div class="stop-menu-service">
        <div class="stop-menu-close-btn" @click="hideStopMenu()">
          <a href="javascript:void(0)"><i class="material-icons">close</i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StopMenuContent from "./StopMenuContent";
import FavouriteButton from '../Favourite/FavouriteButton';

import {mapMutations, mapState} from 'vuex';

export default {
  name: "StopMenu",
  components: {
    StopMenuContent, FavouriteButton
  },
  computed: {
    ...mapState('stopMenu', ['stopDetails', 'loading'])
  },
  methods: {
    ...mapMutations('stopMenu', ['hideStopMenu']),

  },
  mounted() {
  },
}
</script>

<style scoped>
.stop-menu-header {
  position: relative;
}

.stop-menu-content {
  background-color: white;
  padding: 8px;
}

.stop-menu-content h4, .stop-menu-content h5, .stop-menu-content p {
  padding: 0;
  margin: 0;
}

.stop-menu-content h4 {
  font-size: 22px;
  display: inline-block;
}

.stop-menu-service {
  /*position: relative;*/
}

.stop-menu-close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
}

.stop-menu-row {
  margin-bottom: 10px;
}

.favourite-button-wrap {
  display: inline-block;
  vertical-align: bottom;
  margin-left: 4px;
}
</style>
